module.exports = __webpack_public_path__ + "static/img/15.7f08fa56.jpg";